export default __webpack_public_path__ + "static/media/lineTopRight2.abbf9b53.svg";